import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, OnInit } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { BaseComponent } from '@components/base/base';
import { NavbarService } from '@components/navbar/navbar.service';
import { PERMISSIONS, Permissions } from '@models/auth.model';
import { PermissionsService } from '@services/permissions.service';
import { isAdmin } from '@utils/helper';
import { NgxPermissionsService } from 'ngx-permissions';

interface ExampleFlatNode {
  link?: string;
  expandable: boolean;
  name: string;
  level: number;
  type?: SidebarNodeType;
}

type SidebarNodeType = 'admin' | 'back';

type SidebarNode = {
  name: string;
  link?: string;
  type?: SidebarNodeType;
  children?: SidebarNode[];
  roles?: Permissions[];
};

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
})
export class MainLayoutComponent extends BaseComponent implements OnInit {
  isOpen?: boolean = false;


  Menu_User: SidebarNode[] = [
    { name: 'Home', link: '/user/n08' },
    {
      name: 'Quản lý ví và đại lý',
      children: [
        {
          name: 'Danh sách đại lý',
          link: '/user/n08/n082',
        },
        {
          name: 'Ví hoa hồng',
          link: '/user/n09/n091',
        },
        {
          name: 'Danh sách lịch sử tích lũy',
          link: '/user/n09/n093'
        },
        {
          name: 'Lịch sử trả thưởng',
          link: '/user/n09/n092'
        }
      ],
    },
    {
      name: 'Mua hàng',
      children: [
        {
          name: 'Danh sách sản phẩm',
          link: '/user/n13',
        },
        {
          name: 'Danh sách ưu đãi',
          link: '/user/n14',
        },
      ],
    },
    { name: 'Danh sách đơn hàng', link: '/user/n11' },
  ];

  Menu_Admin: SidebarNode[] = [
    { name: 'Home', link: '/', roles: [PERMISSIONS.admin] },
    { name: 'Quản lý banner', link: '/admin/n26/n261', roles: [PERMISSIONS.admin] },
    {
      name: 'Quản lý thành viên',
      children: [
        { name: 'Quản lý User', link: '/admin/n03/n031' },
        { name: 'Quản lý Shop', link: '/admin/n03/n038' },
        { name: 'Quản lý nhân viên', link: '/admin/n03/n310', roles: [PERMISSIONS.admin] },
        // { name: 'Quản lý Store', link: '/admin/n24/n241' },
      ],
      roles: [PERMISSIONS.admin, PERMISSIONS.sale_2]
    },
    {
      name: 'Quản lý đơn hàng',
      link: '/admin/n07',
      roles: [PERMISSIONS.admin],
    },
    {
      name: 'Sản phẩm',
      children: [
        // { name: 'SP chung', link: '/admin/n06' },
        { name: 'SP STORE', link: '/admin/n16/n161' },
        { name: 'SP NBL', link: '/admin/n16/n165' },
        { name: 'SP KHTT', link: '/admin/n16/n163' },
        { name: 'SP săn quà', link: '/admin/n063' },
        { name: 'SP Flashsale ', link: '/admin/n17/n171' },
        { name: 'SP Nutrishop', link: '/admin/n067' },
        { name: 'Duyệt SP Nutrishop', link: '/admin/n069' },
        { name: 'SP năng động', link: '/admin/n16/n167' },
        { name: 'SP kích hoạt CTV', link: '/admin/n16/n162' },
        { name: 'SP kích hoạt shop', link: '/admin/n16/n164' },
        { name: 'Quản lý sản phẩm', link: '/admin/n066' },
      ],
      roles: [PERMISSIONS.admin, PERMISSIONS.sale_1, PERMISSIONS.sale_2],
    },
    {
      name: 'Lịch sử giao dịch',
      children: [
        {
          name: 'Danh sách chuyển tiền',
          link: '/admin/n12/n121',
        },
        {
          name: 'Danh sách thưởng ngoài',
          link: '/admin/n12/n126',
        },
        {
          name: 'Danh sách trả thưởng',
          link: '/admin/n12/n122',
        },
        {
          name: 'Cấu hình mức thưởng',
          link: '/admin/n12/n123',
        },
      ],
      roles: [PERMISSIONS.admin]
    },
    {
      name: 'Hệ thống',
      children: [
        {
          name: 'Quản lí tài khoản ngân hàng',
          link: '/admin/n05/n051',
        },
        {
          name: 'Danh sách ví khu vực',
          link: '/admin/n19/n191',
        },
        {
          name: 'Danh sách ví tỉnh',
          link: '/admin/n19/n193',
        },
        {
          name: 'Lịch sử ví khu vực',
          link: '/admin/n19/n192',
        },
        {
          name: 'Lịch sử ví tỉnh',
          link: '/admin/n19/n194',
        },
        {
          name: 'Danh sách cấu hình',
          link: '/admin/n12/n125',
        },
      ],
      roles: [PERMISSIONS.admin],
    },
    {
      name: 'Công nợ',
      children: [
        {
          name: 'Quản lí công nợ',
          link: '/admin/n23/n231',
        },
        // {
        //   name: 'Danh sách hóa đơn công nợ',
        //   link: '/admin/n23/n232',
        // },
        {
          name: 'Danh sách lịch sử công nợ',
          link: '/admin/n23/n234',
        }
      ],
      roles: [PERMISSIONS.admin],
    },
    {
      name: 'Quản lý kho',
      link: '/admin/n24/n241',
      // link: '/admin/n24/n244',
      roles: [PERMISSIONS.admin],
    },
    {
      name: 'Thống kê',
      children: [
        {
          name: 'Thống kê sản phẩm admin',
          link: '/admin/n25/n251',
        },
        {
          name: 'Thống kê Shop',
          link: '/admin/n25/n252',
        }
      ],
      roles: [PERMISSIONS.admin],
    },
  ];

  Menu_Store: SidebarNode[] = [
    {
      name: 'Thống kê bán hàng',
      link: '/store/n41',
      roles: [PERMISSIONS.store]
    },
    {
      name: 'Số lượng sản phẩm tồn',
      link: '/store/n42',
      roles: [PERMISSIONS.store]
    },
    {
      name: 'Quản lý đơn hàng',
      link: '/store/n44',
      roles: [PERMISSIONS.store]
    },
    {
      name: 'Lịch sử xuất đơn',
      link: '/store/n45',
      roles: [PERMISSIONS.store]
    },
  ]

  Menu_Nutrishop: SidebarNode[] = [
    {
      name: 'Quản lý thành viên',
      children: [
        { name: 'Quản lý Shop', link: '/admin/n03/n038' },
      ],
      roles: [PERMISSIONS.nutrishop_1]
    },
    {
      name: 'Sản phẩm',
      children: [
        { name: 'SP Nutrishop', link: '/admin/n067' },
      ],
      roles: [PERMISSIONS.nutrishop_1],
    },
  ];

  treeControl = new FlatTreeControl<ExampleFlatNode>(
    node => node.level,
    node => node.expandable
  );

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    node => node.level,
    node => node.expandable,
    node => node.children
  );

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  listIconMenu = {};

  constructor(
    private permissionsService: PermissionsService,
    private navbarService: NavbarService
  ) {
    super();
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.unSubOnDestroy(this.permissionsService.userInfo).subscribe({
      next: ({ role }) => {
        const menu = (role === 'STORE') ? this.Menu_Store : (role === 'NUTRISHOP_1' ? this.Menu_Nutrishop : this.Menu_Admin);
        // console.log(menu);
        this.dataSource.data = this.filterMenu(menu, role);
      },
    });
    this.navbarService.isOpen.subscribe((isOpen) => {
      this.isOpen = isOpen;
    })
  }

  filterMenu(menu: SidebarNode[], role: Permissions) {
    return menu
      .filter(({ roles }) => !roles || roles.indexOf(role) > -1)
      .map(item => ({
        ...item,
        children: item.children ? this.filterMenu(item.children, role) : undefined,
      }));
  }

  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;

  onNodeClick(node: SidebarNode) {
    if (node.type === 'admin') {
      this.dataSource.data = this.Menu_Admin;
    }
    if (node.type === 'back') {
      this.dataSource.data = this.Menu_User;
    }
  }

  private _transformer(node: SidebarNode, level: number) {
    return {
      ...node,
      link: node.link,
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      level: level,
    };
  }
}
